// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { PatientHealthConcernRequest } from './patient-health-concern-request';

/** See com.rev360.pms.api.controller.patient.healthconcern.CreatePatientHealthConcernRequest */
/* istanbul ignore next */
@GandalfModel
export class CreatePatientHealthConcernRequest extends PatientHealthConcernRequest {

	@GandalfLabel('Concern')
	@GandalfValidator({ notNull: { message: 'Concern is required' } })
	@GandalfValidator({ sizeString: { message: 'Concern must be between 1 and 255 characters', minLength: 1, maxLength: 255 } })
	@GandalfProperty({ designType: String, isRequired: true })
	concern!: string;

	@GandalfLabel('Date')
	@GandalfValidator({ notNull: { message: 'Date is required' } })
	@GandalfProperty({ propertyType: 'LocalDate', designType: Date, isRequired: true })
	dateReported!: Date;

	@GandalfLabel('Inactive Date')
	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	inactiveDate!: Date | null;

	@GandalfLabel('Patient')
	@GandalfValidator({ notNull: { message: 'Patient is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	patientId!: number;

	@GandalfConstantDecorator(constants.PatientHealthConcernReporter)
	@GandalfLabel('Reporter')
	@GandalfProperty({ designType: constants.PatientHealthConcernReporter })
	reporter!: constants.PatientHealthConcernReporter | null;

	@GandalfConstantDecorator(constants.PatientHealthConcernType)
	@GandalfLabel('Type')
	@GandalfValidator({ notNull: { message: 'Type is required' } })
	@GandalfProperty({ designType: constants.PatientHealthConcernType, isRequired: true })
	type!: constants.PatientHealthConcernType;

}
